import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/users-list';

import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUsersViewInImport from "./components/view-in-import";
import {ITEM_TYPE_PROJECT, ITEM_TYPE_TASK} from "../../../gd/const/item";

export default class TaskUsersField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.USERS;
    }

    get sortHintMessage() {
        return 'Sort by users';
    }

    //currently not in use
    getCsvValue(item) {

        const getUserName = (userId)=>{
            const user = gd.session.users.get(userId);
            return user ? user.name : '';
        };

        return _.map(item.users, user=>getUserName(user.userId ? user.userId /*for tasks*/ : user.id /*for projects*/)).join(', ');
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => {
                let res = 0;
                switch (i.type) {
                    case 'task'             :
                    case ITEM_TYPE_TASK     :
                        res = this.firstTaskUserName(i.item)
                        break

                    case 'project'          :
                    case ITEM_TYPE_PROJECT  :
                        res = this.firstProjectUserName(i.item)
                        break
                }
                return res;
            }],
            directions: [sort]
        }
    }

    firstTaskUserName(item) {
        let firstId;

        if (item.actionRequiredUserId) firstId = item.actionRequiredUserId;
        else if (item.assignedToUserId) firstId = item.assignedToUserId;
        else if (item.users.length > 0) firstId = item.users[0].userId;

        if (!firstId) return '';

        return gd.session.users.get(firstId).name;
    }

    firstProjectUserName(item) {
        let firstId;

        const usersIds = _.orderBy(item.users, [
            user=>{
                let orderRes = 0;
                if (user) {
                    switch (user.role) {
                        case gd.const.project.role.OWNER:           orderRes = 2; break;
                        case gd.const.project.role.PROJECT_MANAGER: orderRes = 1; break;
                    }
                }
                return orderRes;
            },
            user=>gd.session.users.get(user.id).name.toLowerCase()
        ], ['desc','asc']);

        firstId = usersIds[0];

        if (!firstId) return '';

        return gd.session.users.get(firstId).name;
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    // IMPORT

    normalizeCSVValue(value) {

        if (!value) return;

        let errors = false;

        let userNames = value.trim().split(',');
        userNames = _.map(userNames, name=>name.trim())

        const userIds = [];
        _.map(userNames, name=>{
            const userId = mapByUserName(gd.companyId, name);
            if (userId) {
                userIds.push(userId);
            } else {
                userIds.push(name)
                errors = true;
            }
        })

        if (errors) return
        return userIds;
    }

    getComponentViewInImport() {
        return SystemFieldUsersViewInImport;
    }

}
